var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$can('read', 'settlement'))?_c('div',[_c('admin-queue')],1):_c('div',[_c('user-queue')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }